export const ComponentMessages = {
  centralDeRelacionamento: "Central de Relacionamento",
  conhecaODiario: "Conheça o Diário Oficial Eletrônico Minas Gerais"
}
